import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es7.promise.finally.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TeDialog from 'src/components/Dialogs/TEDialog';
import User from 'src/store/models/User';
import { dialog } from 'src/boot/mixins.js';
import { cloneDeep } from 'lodash';
export default {
  mixins: [dialog],
  components: {
    TeDialog: TeDialog
  },
  data: function data() {
    return {
      myUser: null,
      loading: true
    };
  },
  watch: {
    'myUser.settings.dashboardWidgetsMode': function myUserSettingsDashboardWidgetsMode(val) {
      if (!this.isVertical) {
        this.myUser.settings.dashboardSidebarShowInsights = 1;
      }
    }
  },
  computed: {
    isVertical: function isVertical() {
      return ['left', 'right'].includes(this.myUser.settings.dashboardWidgetsMode);
    }
  },
  methods: {
    save: function save() {
      var _this = this;

      this.$q.loading.show();
      User.$updateMe({
        settings: this.myUser.settings
      }).then(function () {
        _this.$q.notify({
          message: _this.$t('components.dashboardSettingsDialog.dashboard_settings_saved'),
          type: 'positive'
        });

        _this.$root.$emit('refresh-weekend-days');

        _this.$refs.dialog.hide();
      }).catch(function () {}).finally(function () {
        _this.$q.loading.hide();
      });
    }
  },
  mounted: function mounted() {
    this.myUser = cloneDeep(this.me);
  }
};